define('frontpage2017',['jquery'],
function ($) {

    var moment = require('moment');
    var body = document.querySelector('body'),
        bannerInterval = null;

    if (body.getAttribute('data-page') === 'frontpage-2017') {

        var navigation = $(body.querySelectorAll('.navigation-container')),
            logo = $(body.querySelectorAll('.navigation-container .logo')),
            teaserContainer = $('.banner-teaser__container'),
            addressList = document.querySelectorAll('.arrangement-article__info-address p');

        $(document).ready(function () {
            bannerInterval = body.querySelector('#interval').childNodes[0].data * 1000;
            if (bannerInterval === 0) {
                bannerInterval = 5000;
            }
        });

        if ($(body).hasClass('highlight frontpage')) {
            $(body).removeClass('highlight');
        }

        /*
         * Carrousel  --------------------------------------
         */
        var myIndex = 0,
            fullText = '';
        carousel();

        function carousel() {


            $(teaserContainer).removeClass('active');
            // $(logo[0]).removeClass('white');
            // $(navigation[0]).removeClass('white');
            $('.show-more').removeClass('active');
            $("body").removeClass("slider-white");

            // Carousel change image loop
            var i;
            var x = document.getElementsByClassName("banner");
            for (i = 0; i < x.length; i++) {
                x[i].style.display = "none";
                $(x[i]).removeClass('active');

            }
            myIndex++;
            if (myIndex > x.length) { myIndex = 1 }
            x[myIndex - 1].style.display = "block";
            $(x[myIndex - 1]).addClass('active');


            // Banner styles
            var bannerText = $(x[myIndex - 1]).find('.banner__text')[0];
            var color = x[myIndex - 1];
            var colorCode = $(color)[0].getAttribute('data-color');

            if (colorCode === 'ffffff') {
                if(!$("body").hasClass("mobile-nav-open")) {
                    $(x[myIndex - 1]).addClass('white');
                    $(logo[0]).addClass('white');
                    $(navigation[0]).addClass('white');
                }
                if($("body").hasClass("megamenu-open")) {
                    $(x[myIndex - 1]).removeClass('white');
                    // $(logo[0]).removeClass('white');
                    // $(navigation[0]).removeClass('white');
                }
                // Add this class to support megamenu
                $("body").addClass("slider-white");
            }

            // Banner text format
            var bannerInnerText = $(bannerText).find('.text')[0];
            var originalText = bannerText;
            fullText = bannerInnerText.innerHTML;

            var teaser = $(teaserContainer).find(".teaser__text");
            $(teaser)[0].innerHTML = bannerInnerText.innerHTML.substring(0, 120) + '...';

            // Carousel timer function
            setTimeout(carousel, bannerInterval);
        }

        /*
        * Click event - Show/hide banner text  --------------------------------------
        */
        $(".show-more").on("click", function (event) {

            if ($(teaserContainer).hasClass('active')) {
                $(teaserContainer).find('.teaser__text')[0].innerHTML = fullText.substring(0, 120) + '...';
            }

            else {

                $(teaserContainer).find('.teaser__text')[0].innerHTML = fullText;
            }

            $(teaserContainer).toggleClass('active');
            $(this).toggleClass('active');
        });



        /*
        * Banner text position --------------------------------------
        */
        $(body.querySelectorAll('.banner__headline')).each(function () {

            var position = $(this)[0].getAttribute('data-text-position'),
            el = $(this);

            var setPosition = function (p) {
                el.addClass(p);
            }

            switch (position) {
                case '1':
                    setPosition('top-left')
                    break;
                case '2':
                    setPosition('top-center')
                    break;
                case '3':
                    setPosition('top-right')
                    break;
                case '4':
                    setPosition('middle-left')
                    break;
                case '5':
                    setPosition('middle-center')
                    break;
                case '6':
                    setPosition('middle-right')
                    break;
                case '7':
                    setPosition('bottom-left')
                    break;
                case '8':
                    setPosition('bottom-center')
                    break;
                case '9':
                    setPosition('bottom-right')
                    break;
                default:
                    setPosition('top-left')
            }

        })

        /*
        * Address formatter. Replace trailing ,.  --------------------------------------
        */
        $(addressList).each(function () {
            $(this)[0].innerHTML = $(this)[0].innerHTML.replace(/,./g, "<br>");
        })
    }

           /*
        * Click event - Show/hide burger menu  --------------------------------------
        */
    $(document).ready(function () {
        $('.burger').click(function () {
            $(this).toggleClass('open');
            var body = $("body");
            var header = $("header.hero-container");
            body.toggleClass("mobile-nav-open");
            if(body.hasClass("mobile-nav-open")) {
                // header.find(".logo").removeClass("white");
                // header.find(".navigation-container").removeClass("white");
                // header.css("background", "#ffffff").css("z-index", "1");
                // header.find(".container").css("background", "#ffffff");
            } else {
                if ($("body").attr('data-page') === 'frontpage-2017') {
                    if($("body").hasClass("slider-white")) {
                        // header.find(".logo").addClass("white");
                        // header.find(".navigation-container").addClass("white");
                    }
                } else {
                    // header.find(".logo").addClass("white");
                    // header.find(".navigation-container").addClass("white");
                }
                // header.css("background", "transparent");
                // header.find(".container").css("background", "transparent");
            }
        });
    });

});



